var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" this can receive class attr to make it lg - md - sm ")])}
var staticRenderFns = []

export { render, staticRenderFns }